import Joi from 'joi';

export const schema = Joi.object().keys({
  closeDate: Joi.date().allow(null).label('Close Date'),
  reviewerComments: Joi.array().label('reviewerComments'),
});
